import { ParametersOmitFirst, ParametersTakeFirst } from "@toolkit/Framework/Types/Common";
import { useSelector } from "react-redux";

const convertSelectorToHooks = <T extends (state: Toolkit.Store.ApplicationState, ...args: any[]) => any>(fn: T) => {
    return (...args: ParametersOmitFirst<T>): ReturnType<T> => {
        return useSelector((state: ParametersTakeFirst<T>) => fn(state, ...args));
    };
};

export default convertSelectorToHooks;
